<template>
  <footer class="navbar navbar-expand-lg py-2">
    <div class="container d-block d-md-flex">
      <a
        href="tel:+33299149547"
        class="d-block m-2 ml-md-0 mr-md-auto font-size-sm text-white font-weight-normal"
      >
        <img src="@/assets/ico-phone.svg" class="svg mr-1">
        +33 (0)2 99 14 95 47
      </a>
      <router-link
        class="d-block m-2 m-md-0 text-white font-weight-normal"
        to="/legal"
      >Mentions légales et CGV</router-link>
      <router-link
        class="d-block m-2 ml-md-4 text-white font-weight-normal"
        to="/contact"
      >Vous avez une demande particulière ?</router-link>
      <a
        href="http://www.space.fr/"
        target="_blank"
        rel="noopener"
        class="d-block m-2 ml-md-4 mr-md-0 text-white font-weight-normal"
      >Site du SPACE 2024</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style lang="scss" scoped>
footer {
  font-size: 0.8rem;
  background: #003242;
}
</style>
